import { PlanogramProductSchema } from "@labeling-tools/api/atlas";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export interface PlanoDimension {
  x0: number;
  x1: number;
  y0: number;
  y1: number;
  w: number;
  h: number;
}

export const getLabelDimension = (label: PlanogramProductSchema) => {
  const labelDimension: PlanoDimension = {
    x0: Infinity,
    x1: -Infinity,
    y0: Infinity,
    y1: -Infinity,
    w: 0,
    h: 0,
  };

  label.points.forEach(({ x, y }) => {
    if (labelDimension.x0 > x) labelDimension.x0 = x;
    if (labelDimension.x1 < x) labelDimension.x1 = x;
    if (labelDimension.y0 > y) labelDimension.y0 = y;
    if (labelDimension.y1 < y) labelDimension.y1 = y;
  });

  labelDimension.w = labelDimension.x1 - labelDimension.x0;
  labelDimension.h = labelDimension.y1 - labelDimension.y0;

  return labelDimension;
};

export const getPlanoDimension = (
  planogramLabels: PlanogramProductSchema[],
) => {
  const planoDimension: PlanoDimension = {
    x0: Infinity,
    x1: -Infinity,
    y0: Infinity,
    y1: -Infinity,
    w: 0,
    h: 0,
  };

  planogramLabels.forEach((label) => {
    label.points.forEach(({ x, y }) => {
      if (planoDimension.x0 > x) planoDimension.x0 = x;
      if (planoDimension.x1 < x) planoDimension.x1 = x;
      if (planoDimension.y0 > y) planoDimension.y0 = y;
      if (planoDimension.y1 < y) planoDimension.y1 = y;
    });
  });

  planoDimension.w = planoDimension.x1 - planoDimension.x0;
  planoDimension.h = planoDimension.y1 - planoDimension.y0;

  return planoDimension;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
